import { animate, keyframes, style, AnimationBuilder } from '@angular/animations';
import { Component, ElementRef, Input, HostBinding, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from '@onep/ng-uikit-lib/icon';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/animations';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@onep/ng-uikit-lib/icon';

const _c0 = ["onepButton", ""];
const _c1 = function (a0) { return { "hide-icon": a0 }; };
const _c2 = function (a0) { return { "font-size": a0 }; };
const _c3 = ["*"];
const loadingAnimation = animate('1.5s ease-out', keyframes([
    // tslint:disable-next-line:object-literal-key-quotes
    style({ 'width': 0, 'height': '100%' }),
    // tslint:disable-next-line:object-literal-key-quotes
    style({ 'width': '40%', 'height': '100%' }),
    // tslint:disable-next-line:object-literal-key-quotes
    style({ 'width': '52%', 'height': '100%' }),
    // tslint:disable-next-line:object-literal-key-quotes
    style({ 'width': '65%', 'height': '100%' }),
    // tslint:disable-next-line:object-literal-key-quotes
    style({ 'width': '77%', 'height': '100%' }),
    // tslint:disable-next-line:object-literal-key-quotes
    style({ 'width': '80%', 'height': '100%' }),
    // tslint:disable-next-line:object-literal-key-quotes
    style({ 'width': '81%', 'height': '100%' }),
    // tslint:disable-next-line:object-literal-key-quotes
    style({ 'width': '83%', 'height': '100%' }),
    // tslint:disable-next-line:object-literal-key-quotes
    style({ 'width': '84%', 'height': '100%' }),
    // tslint:disable-next-line:object-literal-key-quotes
    style({ 'width': '85%', 'height': '100%' })
]));
/**
 * Component that works as a directive for HTML button.
 */
class ButtonComponent {
    constructor(builder, el) {
        this.builder = builder;
        this.el = el;
        /**
         * Input that sets different type of button
         * 'primary' | 'secondary' | 'tertiary' | 'icon' | 'icon-table' | 'gradient'
         * Default: 'primary'
         */
        this.onepButtonType = 'primary';
        /**
         * Input for Button size : 'normal' | 'small' | 'mini'
         */
        this.size = 'normal';
        /**
         * @deprecated Input for small Button (deprecated: please use property "size")
         */
        this.small = false;
        /**
         * Input that set if button is in loading state
         */
        this.loading = false;
        /**
         * Input that set icon name if icon type is button
         */
        this.iconName = '';
        /**
         * Input that set icon name if icon type is button
         */
        this.iconSize = 24;
        /**
         * Input that set if button is in loading state
         */
        this.font = 'roboto';
        this.onepButtonClass = true;
        this.onepButtonSmallClass = false;
        this.onepButtonMiniClass = false;
        this.onepTextButton = true;
        this.onepTextButtonSmall = false;
        this.onepButtonLoadingClass = false;
        this.onepButtonPrimaryClass = false;
        this.onepButtonSecondaryClass = false;
        this.onepButtonTertiaryClass = false;
        this.onepButtonIconClass = false;
        this.onepButtonIconTableClass = false;
        this.onepButtonGradientClass = false;
        this.onepButtonHoverClass = false;
        this.onepButtonFocusClass = false;
        this.onepButtonRobotoCondensed = false;
        this.loadAnimations = undefined;
    }
    processType() {
        switch (this.font) {
            default:
            case 'roboto':
                this.onepButtonRobotoCondensed = false;
                break;
            case 'roboto-condensed':
                this.onepButtonRobotoCondensed = true;
                break;
        }
        switch (this.onepButtonType) {
            default:
            case 'primary':
                this.setButtonClass(false, true, false, false, false, false);
                this.loadAnimations = loadingAnimation;
                break;
            case 'secondary':
                this.setButtonClass(false, false, true, false, false, false);
                this.loadAnimations = loadingAnimation;
                break;
            case 'tertiary':
                this.setButtonClass(true, false, false, false, false, false);
                break;
            case 'icon':
                this.setButtonClass(false, false, false, true, false, false);
                break;
            case 'icon-table':
                this.setButtonClass(false, false, false, false, true, false);
                break;
            case 'gradient':
                this.setButtonClass(false, false, false, false, false, true);
                break;
        }
        if (this.small) {
            this.onepTextButtonSmall = true;
            this.onepButtonSmallClass = true;
        }
        switch (this.size) {
            default:
            case 'normal':
                this.onepTextButtonSmall = false;
                this.onepButtonSmallClass = false;
                this.onepButtonMiniClass = false;
                break;
            case 'small':
                this.onepTextButtonSmall = true;
                this.onepButtonSmallClass = true;
                break;
            case 'mini':
                this.onepTextButtonSmall = true;
                this.onepButtonMiniClass = true;
                break;
        }
    }
    setButtonClass(onepButtonTertiaryClass, onepButtonPrimaryClass, onepButtonSecondaryClass, onepButtonIconClass, onepButtonIconTableClass, onepButtonGradientClass) {
        this.onepButtonTertiaryClass = onepButtonTertiaryClass;
        this.onepButtonPrimaryClass = onepButtonPrimaryClass;
        this.onepButtonSecondaryClass = onepButtonSecondaryClass;
        this.onepButtonIconClass = onepButtonIconClass;
        this.onepButtonIconTableClass = onepButtonIconTableClass;
        this.onepButtonGradientClass = onepButtonGradientClass;
    }
    animate() {
        if (this.loadAnimations) {
            if (this.player) {
                this.player.destroy();
            }
            const factory = this.builder.build(this.loadAnimations);
            const player = factory.create(this.el.nativeElement.querySelector('.onep-button-background-loading'));
            player.play();
        }
    }
    ngOnInit() {
        if (this.loading) {
            this.onepButtonLoadingClass = true;
            this.animate();
        }
        else {
            this.onepButtonLoadingClass = false;
        }
        this.processType();
    }
    ngOnChanges() {
        if (this.loading) {
            this.onepButtonLoadingClass = true;
            this.animate();
        }
        else {
            this.onepButtonLoadingClass = false;
        }
        this.processType();
    }
}
ButtonComponent.ɵfac = function ButtonComponent_Factory(t) { return new (t || ButtonComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.AnimationBuilder), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
ButtonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ButtonComponent, selectors: [["button", "onepButton", ""]], hostVars: 30, hostBindings: function ButtonComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("onep-button", ctx.onepButtonClass)("onep-button-small", ctx.onepButtonSmallClass)("onep-button-mini", ctx.onepButtonMiniClass)("onep-text-button", ctx.onepTextButton)("onep-text-button-small", ctx.onepTextButtonSmall)("onep-button-loading", ctx.onepButtonLoadingClass)("onep-button-primary", ctx.onepButtonPrimaryClass)("onep-button-secondary", ctx.onepButtonSecondaryClass)("onep-button-tertiary", ctx.onepButtonTertiaryClass)("onep-button-icon", ctx.onepButtonIconClass)("onep-button-icon-table", ctx.onepButtonIconTableClass)("onep-button-gradient", ctx.onepButtonGradientClass)("hover", ctx.onepButtonHoverClass)("focus", ctx.onepButtonFocusClass)("roboto-condensed", ctx.onepButtonRobotoCondensed);
    } }, inputs: { onepButtonType: "onepButtonType", size: "size", small: "small", loading: "loading", iconName: "iconName", iconSize: "iconSize", font: "font" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], attrs: _c0, ngContentSelectors: _c3, decls: 5, vars: 7, consts: [[1, "onep-button-background-loading"], [1, "onep-button-label"], [1, "onep-button-icon", 3, "ngClass"], [3, "onepIcon", "ngStyle"]], template: function ButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelement(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelement(4, "svg", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c1, ctx.onepButtonType !== "icon" && ctx.onepButtonType !== "icon-table"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("onepIcon", ctx.iconName)("ngStyle", ɵngcc0.ɵɵpureFunction1(5, _c2, ctx.iconSize + "px"));
    } }, dependencies: [ɵngcc2.NgClass, ɵngcc2.NgStyle, ɵngcc3.IconComponent] });
ButtonComponent.ctorParameters = () => [
    { type: AnimationBuilder },
    { type: ElementRef }
];
ButtonComponent.propDecorators = {
    onepButtonType: [{ type: Input }],
    size: [{ type: Input }],
    small: [{ type: Input }],
    loading: [{ type: Input }],
    iconName: [{ type: Input }],
    iconSize: [{ type: Input }],
    font: [{ type: Input }],
    onepButtonClass: [{ type: HostBinding, args: ['class.onep-button',] }],
    onepButtonSmallClass: [{ type: HostBinding, args: ['class.onep-button-small',] }],
    onepButtonMiniClass: [{ type: HostBinding, args: ['class.onep-button-mini',] }],
    onepTextButton: [{ type: HostBinding, args: ['class.onep-text-button',] }],
    onepTextButtonSmall: [{ type: HostBinding, args: ['class.onep-text-button-small',] }],
    onepButtonLoadingClass: [{ type: HostBinding, args: ['class.onep-button-loading',] }],
    onepButtonPrimaryClass: [{ type: HostBinding, args: ['class.onep-button-primary',] }],
    onepButtonSecondaryClass: [{ type: HostBinding, args: ['class.onep-button-secondary',] }],
    onepButtonTertiaryClass: [{ type: HostBinding, args: ['class.onep-button-tertiary',] }],
    onepButtonIconClass: [{ type: HostBinding, args: ['class.onep-button-icon',] }],
    onepButtonIconTableClass: [{ type: HostBinding, args: ['class.onep-button-icon-table',] }],
    onepButtonGradientClass: [{ type: HostBinding, args: ['class.onep-button-gradient',] }],
    onepButtonHoverClass: [{ type: HostBinding, args: ['class.hover',] }],
    onepButtonFocusClass: [{ type: HostBinding, args: ['class.focus',] }],
    onepButtonRobotoCondensed: [{ type: HostBinding, args: ['class.roboto-condensed',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ButtonComponent, [{
        type: Component,
        args: [{ selector: 'button[onepButton]', template: "<div class=\"onep-button-background-loading\"></div>\n<div class=\"onep-button-label\"><ng-content></ng-content></div>\n<div class=\"onep-button-icon\" [ngClass]=\"{'hide-icon': onepButtonType !== 'icon' && onepButtonType !== 'icon-table'}\">\n  <svg [onepIcon]=\"iconName\" [ngStyle]=\"{ 'font-size': iconSize + 'px'}\"/>\n</div>\n" }]
    }], function () { return [{ type: ɵngcc1.AnimationBuilder }, { type: ɵngcc0.ElementRef }]; }, { onepButtonType: [{
            type: Input
        }], size: [{
            type: Input
        }], small: [{
            type: Input
        }], loading: [{
            type: Input
        }], iconName: [{
            type: Input
        }], iconSize: [{
            type: Input
        }], font: [{
            type: Input
        }], onepButtonClass: [{
            type: HostBinding,
            args: ['class.onep-button']
        }], onepButtonSmallClass: [{
            type: HostBinding,
            args: ['class.onep-button-small']
        }], onepButtonMiniClass: [{
            type: HostBinding,
            args: ['class.onep-button-mini']
        }], onepTextButton: [{
            type: HostBinding,
            args: ['class.onep-text-button']
        }], onepTextButtonSmall: [{
            type: HostBinding,
            args: ['class.onep-text-button-small']
        }], onepButtonLoadingClass: [{
            type: HostBinding,
            args: ['class.onep-button-loading']
        }], onepButtonPrimaryClass: [{
            type: HostBinding,
            args: ['class.onep-button-primary']
        }], onepButtonSecondaryClass: [{
            type: HostBinding,
            args: ['class.onep-button-secondary']
        }], onepButtonTertiaryClass: [{
            type: HostBinding,
            args: ['class.onep-button-tertiary']
        }], onepButtonIconClass: [{
            type: HostBinding,
            args: ['class.onep-button-icon']
        }], onepButtonIconTableClass: [{
            type: HostBinding,
            args: ['class.onep-button-icon-table']
        }], onepButtonGradientClass: [{
            type: HostBinding,
            args: ['class.onep-button-gradient']
        }], onepButtonHoverClass: [{
            type: HostBinding,
            args: ['class.hover']
        }], onepButtonFocusClass: [{
            type: HostBinding,
            args: ['class.focus']
        }], onepButtonRobotoCondensed: [{
            type: HostBinding,
            args: ['class.roboto-condensed']
        }] }); })();

/**
 * Module that provides the button component.
 */
class ButtonModule {
}
ButtonModule.ɵfac = function ButtonModule_Factory(t) { return new (t || ButtonModule)(); };
ButtonModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ButtonModule });
ButtonModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule, IconModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ButtonModule, [{
        type: NgModule,
        args: [{
                declarations: [ButtonComponent],
                imports: [CommonModule, IconModule],
                exports: [ButtonComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ButtonModule, { declarations: function () { return [ButtonComponent]; }, imports: function () { return [CommonModule, IconModule]; }, exports: function () { return [ButtonComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ButtonComponent, ButtonModule };

